// Firebase configuration
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyDji2LxqTvq-bnOmY-fQumsMY5qhfT-wp8",
  authDomain: "canvassed-d9cdb.firebaseapp.com",
  projectId: "canvassed-d9cdb",
  storageBucket: "canvassed-d9cdb.firebasestorage.app",
  messagingSenderId: "609606225540",
  appId: "1:609606225540:web:f6b4d1c440b95cfd953cd1",
  measurementId: "G-TVSR39G54W"
};

// Initialize Firebase only if it hasn't been initialized already
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics only in production (optional)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export const FIREBASE_PROJECT_ID = firebaseConfig.projectId;

export default app;
